module.exports = __webpack_public_path__ + "img/ziggurat_tech_Normal_ua.61a131e2.webp";